export const OPEN_EXIT_DIALOG = 'OPEN_EXIT_DIALOG' as const;
export const CLOSE_EXIT_DIALOG = 'CLOSE_EXIT_DIALOG' as const;

export const openExitDialog = () => {
  return {
    type: OPEN_EXIT_DIALOG,
  };
};

export const closeExitDialog = () => ({
  type: CLOSE_EXIT_DIALOG,
});
